import Link from 'next/link';
import styles from './styles.module.css';

type BreadcrumbItem = {
  link?: string;
  title: string;
};

type BreadcrumbsProps = {
  crumbs: BreadcrumbItem[];
};

const BreadcrumbItem = ({ item }: { item: BreadcrumbItem }) => {
  if (!item.link)
    return <span className={styles.crumbsItem}>{item.title}</span>;

  return (
    <Link href={item.link} className={`${styles.crumbsItem} ${styles.hover}`}>
      {item.title}
    </Link>
  );
};

const Breadcrumbs = ({ crumbs }: BreadcrumbsProps) => {
  return (
    <div className={styles.crumbsContent}>
      {crumbs.map((item, index) => (
        <BreadcrumbItem key={index} item={item} />
      ))}
    </div>
  );
};

export default Breadcrumbs;
